import { Utility } from '../utility/utility_controller'
import { attachHlsIfNeeded } from './hls_loader'

var loadBackgroundVideo = function () {
	switch (Utility.screenSize) {
		case 'desktop':
		case 'tablet':
			if (jQuery('.lay-sitewide-background-video').length > 0 && jQuery('.lay-sitewide-background-video').attr('src') == undefined) {
				var video_url = jQuery('.lay-sitewide-background-video').attr('data-src')
				jQuery('.lay-sitewide-background-video').attr('src', video_url)
			}
			if (jQuery('.lay-sitewide-background-video').length > 0) {
				attachHlsIfNeeded(jQuery('.lay-sitewide-background-video')[0])
				jQuery('.lay-sitewide-background-video')[0].play()
			}
			break
		case 'phone':
			if (jQuery('.lay-sitewide-background-video-mobile').length > 0 && jQuery('.lay-sitewide-background-video-mobile').attr('src') == undefined) {
				var video_url = jQuery('.lay-sitewide-background-video-mobile').attr('data-src')
				jQuery('.lay-sitewide-background-video-mobile').attr('src', video_url)
			}
			if (jQuery('.lay-sitewide-background-video-mobile').length > 0) {
				attachHlsIfNeeded(jQuery('.lay-sitewide-background-video-mobile')[0])
				jQuery('.lay-sitewide-background-video-mobile')[0].play()
			}
			break
	}
}

var i = function () {
	loadBackgroundVideo()
	window.laytheme.on('sizechanged', function () {
		loadBackgroundVideo()
	})
}

var video_background = {
	i: i,
}

export default video_background
